// extracted by mini-css-extract-plugin
export default {"selectAll":"cK7nu9shjRHB3NaXkC3z","partnerSectionError":"D1H7X6e2M1aup2cUXHHQ"};